import cx from "classnames";
import React, { useEffect, useState } from "react";
import TreeView, { flattenTree } from "react-accessible-treeview";
import { Button, Col, Form, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { BiSolidPencil } from "react-icons/bi";
import {
  FaCheckSquare,
  FaMinusSquare,
  FaRegTrashAlt,
  FaSquare
} from "react-icons/fa";
import { IoMdArrowDropright } from "react-icons/io";
import { useLocation, useParams } from "react-router-dom";
import addico from "../../assets/images/add.svg";
import addico1 from "../../assets/images/add1.svg";
import {
  deleteSurveySections,
  getAllSurveySections,
  getSectionById,
  insertSurveySections,
  updateSurveySections,
} from "../../utils/ApiUrl";
import { axiosPost } from "../../utils/AxiosHelper";
import { decrypt } from "../../utils/common";
import SurveySectionQuestionList from "./SurveySectionQuestionList";
//  import "./SurveySectionList.scss";
import crossico from "../../assets/images/close.svg";
import ESInput from "../../controls/ESInput";
import ESTooltip from "../../controls/ESTooltip";
import { showToast, ToastTypeCode } from "../../utils/Constant";
import Loader from "../loader/Loader";
import ConfirmationPopup from "../popUp/ConfirmationPopup";
import "./SurveySectionList.scss";

interface SurveySectionedit {
  SurveySectionId?: number;
  SectionTitle: string;
  SectionInstructions: string;
  ParentId: number;
  SurveyFormId: number;
  OrganizationId: number;
  CreateUserId: number;
  CreateDate: string;
  UpdateUserId?: number | null;
  UpdateDate?: string | null;
  InternalKey: string;
  ConcurrencyKey: string;
  IsDemography?: boolean;
}

export interface SurveySectionProps {
  surveyId: any;
  organizationId?: number | null;
  routeFlag?: number;
}

interface Section {
  SectionTitle: string;
  SurveySectionId: number;
  SurveySubSection?: Section[];
}

interface TreeNode {
  name: string;
  id: number;
  children: TreeNode[];
}

const SurveySectionList: React.FC<SurveySectionProps> = ({
  surveyId,
  organizationId,
  routeFlag,
}) => {
  const { id } = useParams();

  const [data, setData] = useState<any>();

  useEffect(() => {
    if (id) {
      const fetchData = async () => {
        const survey = await decrypt(id);
        setData(survey);
      };
      fetchData();
    }
  }, []);

  var surveyFormId: string | undefined = data;
  surveyFormId = surveyId;

  const [surveySections, setSurveySections] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isDemography, SetIsDemography] = useState(false);
  const [isDemographyToPass, SetIsDemographyToPass] = useState(false);
  const [selectedSectionId, setSelectedSectionId] = useState<number | null>(
    null
  );
  const [sectionData, setSectionData] = useState<SurveySectionedit>({
    SurveySectionId: undefined,
    SectionTitle: "",
    SectionInstructions: "",
    ParentId: 0,
    SurveyFormId: 0,
    OrganizationId: 0,
    CreateUserId: 0,
    CreateDate: "",
    UpdateUserId: null,
    UpdateDate: null,
    InternalKey: "",
    ConcurrencyKey: "",
  });
  const [creatingSection, setCreatingSection] = useState(false);
  const [editingSection, setEditingSection] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(30);
  const [sortBy, setSortBy] = useState<string>("CreateDate");
  const [sortDir, setSortDir] = useState<string>("ASC");
  const [searchText, setSearchText] = useState<string>("");
  const [showPopup, setShowPopup] = useState(false);
  const [deleteId, setDeleteId] = useState<number | null>(null);
  const [treeData, setTreeData] = useState<any>(null);
  const [defaultValueForSection, setDefaultValueForSection] = useState<
    number[]
  >([]);
  const [
    afterCreateDefaultValueForSection,
    setAfterCreateDefaultValueForSection,
  ] = useState<number[]>([]);
  const [isDeleted, setIsDeleted] = useState<boolean>(false);
  const [showFormProp, setShowFormProp] = useState(false);
  const [rerenderFlag, setRerenderFlag] = useState<boolean>(false);
  const location = useLocation();
  const methods = useForm();

  const handleAddSurveySection = async (data: any) => {
    const { sectionName } = data;
    if (!sectionName.trim()) {
      showToast("Section name cannot be empty", ToastTypeCode?.ERROR);
      return;
    }
    const existingDemographyCount = surveySections?.filter(sec => sec?.IsDemography)?.length;
    if (existingDemographyCount + (data?.IsDemography ? 1 : 0) > 1) {
      showToast("Only one section can be demography", ToastTypeCode?.ERROR);
      return;
    }
    setLoading(true);
    try {
      const response: any = await axiosPost(insertSurveySections, {
        SectionTitle: sectionName,
        SurveyFormId: surveyFormId,
        ParentId: sectionData.ParentId,
        OrganizationId: organizationId,
        IsDemography: data?.IsDemography ? 1 : 0,
        IsActive: true,
      });

      if (response?.data?.Status === 200) {
        fetchSurveySections();
        setCreatingSection(false);
        SetIsDemography(false);
        setAfterCreateDefaultValueForSection([response?.data?.ExtraData]);
        methods.reset();
        showToast((location.state?.routeFlag === 2 ? 'Quiz Section Added' : 'Form Section Added'), ToastTypeCode?.SUCCESS);
        setShowFormProp(true);
      } else {
        showToast(response?.data?.ExtraData, ToastTypeCode?.ERROR);
      }
    } catch (error) {
      showToast("Something went wrong", ToastTypeCode?.ERROR);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateSurveySection = async (data: any) => {
    const { sectionName } = data;

    const existingDemographyCount = surveySections?.filter(sec => sec?.IsDemography)?.length;
    if (existingDemographyCount + (data?.IsDemography ? 1 : 0) > 1) {
      showToast("Only one section can be demography", ToastTypeCode?.ERROR);
      return;
    }

    if (!sectionName.trim()) {
      showToast("Section name cannot be empty", ToastTypeCode?.ERROR);
      return;
    }
    setLoading(true);
    try {
      const updatedData = {
        ...sectionData,
        SectionTitle: sectionName,
        OrganizationId: organizationId,
        IsDemography: isDemography ? 1 : 0,
        IsActive: true,
      };

      const response: any = await axiosPost(updateSurveySections, updatedData);

      if (response.data?.Status === 200) {
        fetchSurveySections();
        setEditingSection(false);
        SetIsDemography(false);
        methods.reset();
        showToast((location.state?.routeFlag === 2 ? 'Quiz Section Updated' : 'Form Section Updated'), ToastTypeCode?.SUCCESS);
      } else {
        showToast(response?.data?.ErrorMessage, ToastTypeCode?.ERROR);
      }
    } catch (error) {
      showToast("Something went wrong while updating the section", ToastTypeCode?.ERROR);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelSection = () => {
    setCreatingSection(false);
    setEditingSection(false);
    methods.reset();
  };

  const handleEditSectionClick = async (id: any) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    try {
      const response: any = await axiosPost(getSectionById, {
        SurveySectionId: id,
      });

      if (response.data?.Status === 200) {
        const data = response.data.ExtraData;
        setSectionData(data);
        setEditingSection(true);
        setCreatingSection(false);
        SetIsDemography(data?.IsDemography ? data?.IsDemography : false);
        methods.setValue("sectionName", data.SectionTitle);
      } else {
        showToast(response?.data?.ErrorMessage, ToastTypeCode?.ERROR);
      }
    } catch (error) {
      showToast("Something went wrong while fetching the data", ToastTypeCode?.ERROR);
    }
  };

  useEffect(() => {
    if (surveyId) {
      fetchSurveySections();
    }
  }, [surveyId]);

  const handleAddSectionClick = () => {
    setCreatingSection(true);
    if (selectedSectionId !== null) {
      setSectionData((prevState) => ({
        ...prevState,
        ParentId: selectedSectionId,
      }));
    } else {
      setSectionData((prevState) => ({
        ...prevState,
        ParentId: 0,
      }));
    }
  };

  const fetchSurveySections = async () => {
    setLoading(true);
    setError(null);
    try {
      const response: any = await axiosPost(getAllSurveySections, {
        SearchText: searchText,
        IsActive: true,
        CurrentPageNo: currentPage,
        PageSize: pageSize,
        SortDir: sortDir,
        SortBy: sortBy,
        SurveyFormId: surveyFormId,
        OrganizationId: organizationId,
      });
      let dbSections = response.data.ExtraData || [];

      if (dbSections.length > 0) {
        setSelectedSectionId(dbSections[0].SurveySectionId);
      } else {
        setSelectedSectionId(null);
      }
      setSurveySections(dbSections);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteSectionClick = (sectionId: any) => {
    setDeleteId(sectionId);
    setShowPopup(true);
  };

  const confirmDeleteSection = async () => {
    if (deleteId === null) return;

    try {
      setLoading(true);
      const response: any = await axiosPost(deleteSurveySections, {
        SurveySectionId: deleteId,
        SurveyFormId: surveyFormId,
      });
      if (response.data?.Status === 200) {
        setIsDeleted(true);
        fetchSurveySections();
        setCreatingSection(false);
        setSelectedSectionId(null);
        showToast((location.state?.routeFlag === 2 ? 'Quiz Section Deleted' : 'Form Section Deleted'), ToastTypeCode?.SUCCESS);
      } else {
        showToast(response?.data?.ExtraData, ToastTypeCode?.ERROR);
      }
    } catch (error) {
      showToast("Something went wrong", ToastTypeCode?.ERROR);
    } finally {
      setLoading(false);
      setShowPopup(false);
      setDeleteId(null);
    }
  };

  useEffect(() => {
    const updatedTreeData = flattenTree({
      name: "",
      children: buildTreeNodes(surveySections),
    });
    setTreeData(updatedTreeData);
    if (surveySections?.length > 0) {
      if (afterCreateDefaultValueForSection) {
        setDefaultValueForSection(afterCreateDefaultValueForSection);
      }
      setDefaultValueForSection([surveySections[0].SurveySectionId]);
      setRerenderFlag((prev) => !prev);
    }
  }, [surveySections]);

  const handleSectionClick = (sectionId: number) => {
    setShowFormProp(false);
    setAfterCreateDefaultValueForSection([]);
    if (sectionId === selectedSectionId) {
      setSelectedSectionId(null);
    } else {
      setSelectedSectionId(sectionId);
    }
  };

  useEffect(() => {
    if (selectedSectionId === null) {
      SetIsDemographyToPass(false);
    } else {
      const selectedSection = surveySections?.find(
        (section) => section?.SurveySectionId === selectedSectionId
      );
      SetIsDemographyToPass(selectedSection?.IsDemography ?? false);
    }
  }, [selectedSectionId, surveySections]);

  const handleAddSubSectionClick = (parentId: any) => {
    setCreatingSection(true);
    setSectionData((prevState) => ({
      ...prevState,
      ParentId: parentId,
    }));
  };

  const buildTreeNodes = (sections: Section[]): TreeNode[] => {
    return sections?.map((section) => ({
      name: section.SectionTitle,
      id: section.SurveySectionId,
      children: section.SurveySubSection
        ? buildTreeNodes(section.SurveySubSection)
        : [],
    }));
  };

  return (
    <div className="wrap-SureveySectionQuestion">
      <div className="SureveySectionQuestion-blk">
        <Row>
          <Col md={3}>
            <div className="survey-section-list">
              <div className="title d-block">
                <h2 className="page-title me-5">Section</h2>

                <ESTooltip
                  text={
                    creatingSection || editingSection ? "Close" : "Add Section"
                  }
                  placement="top"
                >
                  <Button
                    onClick={
                      creatingSection || editingSection
                        ? handleCancelSection
                        : handleAddSectionClick
                    }
                    className="primary-btn btn-add"
                  >
                    {creatingSection || editingSection ? (
                      <img src={crossico} className="closeico" alt="close" />
                    ) : (
                      <img src={addico} alt="add" />
                    )}
                  </Button>
                </ESTooltip>
              </div>
              {error && <p>{error}</p>}
              {!loading && !error && (
                <>
                  {(creatingSection || editingSection) && (
                    <div className="sub-card mt-2">
                      <Row>
                        <FormProvider {...methods}>
                          <Form
                            onSubmit={methods.handleSubmit(
                              creatingSection
                                ? handleAddSurveySection
                                : handleUpdateSurveySection
                            )}
                          >
                            <Form.Group as={Row}>
                              <Form.Label>
                                Section <span className="text-danger">*</span>
                              </Form.Label>

                              <Col>
                                <ESInput
                                  name="sectionName"
                                  type="text"
                                  placeholder="Section name"
                                  required
                                  className="form-control"
                                />
                              </Col>
                            </Form.Group>
                            <Form.Group
                              as={Row}
                              className="mt-2 mb-2"
                              controlId="IsDemography"
                            >
                              <Col>
                                <Form.Check
                                  type="checkbox"
                                  {...methods.register("IsDemography")}
                                  label="Is Demography"
                                  checked={isDemography}
                                  disabled={!creatingSection}
                                  onChange={(e) => SetIsDemography(e.target.checked)}
                                />
                              </Col>
                            </Form.Group>
                            <Col>
                              {creatingSection ? (
                                <Button type="submit" className="save-btn">
                                  Save
                                </Button>
                              ) : (
                                <Button type="submit" className="save-btn">
                                  Update
                                </Button>
                              )}
                              <Button
                                onClick={handleCancelSection}
                                className="back-btn"
                              >
                                Cancel
                              </Button>
                            </Col>
                          </Form>
                        </FormProvider>
                      </Row>
                    </div>
                  )}

                  <TreeView
                    key={rerenderFlag ? 1 : 0}
                    data={treeData}
                    aria-label="Survey Section Tree"
                    propagateSelect
                    propagateSelectUpwards
                    togglableSelect
                    defaultSelectedIds={defaultValueForSection}
                    nodeRenderer={({
                      element,
                      isBranch,
                      isExpanded,
                      isSelected,
                      isHalfSelected,
                      getNodeProps,
                      level,
                      handleSelect,
                      handleExpand,
                    }) => {
                      return (
                        <div
                          {...getNodeProps({ onClick: handleExpand })}
                          style={{ marginLeft: 12 * (level - 1) }}
                        >
                          {isBranch && (
                            <ArrowIcon
                              isOpen={isExpanded}
                              className={undefined}
                            />
                          )}
                          <CheckBoxIcon
                            className="checkbox-icon"
                            onClick={(e) => {
                              handleSelect(e);
                              e.stopPropagation();
                              handleSectionClick(Number(element.id));
                            }}
                            variant={
                              isHalfSelected
                                ? "some"
                                : isSelected
                                  ? "all"
                                  : "none"
                            }
                            element={element}
                          />
                          <span className="name">
                            {element.name}
                            <span className="treelist-actions">
                              <ESTooltip text="Edit Section" placement="top">
                                <button
                                  onClick={() =>
                                    handleEditSectionClick(element.id)
                                  }
                                  className="btnicon"
                                >
                                  <BiSolidPencil color="#529c25" size={14} />
                                </button>
                              </ESTooltip>
                              <ESTooltip text="Delete Section" placement="top">
                                <button
                                  onClick={() =>
                                    handleDeleteSectionClick(element.id)
                                  }
                                  className="btnicon"
                                > <FaRegTrashAlt color="#ff3610" size={14} />
                                </button>
                              </ESTooltip>
                            </span>
                          </span>
                        </div>
                      );
                    }}
                  />
                  <ConfirmationPopup
                    show={showPopup}
                    message="Are you sure you want to delete?"
                    onConfirm={confirmDeleteSection}
                    onCancel={() => setShowPopup(false)}
                  />
                </>
              )}
            </div>
          </Col>
          <Col md={9}>
            {selectedSectionId && (
              <SurveySectionQuestionList
                sectionId={selectedSectionId}
                onEdit={handleEditSectionClick}
                isDeleted={isDeleted}
                isDemography={isDemographyToPass}
                surveyFormId={surveyFormId}
                organizationId={organizationId}
                showFormProp={showFormProp}
                routeFlag={routeFlag ?? location.state?.routeFlag}
              />
            )}
          </Col>
        </Row>
        {loading ? <Loader /> : null}
        {/* </CardBody>
        </Card> */}
      </div>
    </div>
  );
};

const ArrowIcon = ({
  isOpen,
  className,
}: {
  isOpen: boolean;
  className?: string;
}) => {
  const baseClass = "arrow";
  const classes = cx(
    baseClass,
    { [`${baseClass}--closed`]: !isOpen },
    { [`${baseClass}--open`]: isOpen },
    className
  );
  return <IoMdArrowDropright className={classes} />;
};
type CheckBoxVariant = "all" | "none" | "some";

interface CheckBoxIconProps extends React.AllHTMLAttributes<SVGElement> {
  variant: CheckBoxVariant;
}

const CheckBoxIcon = ({
  variant,
  className,
  onClick,
  element,
  ...rest
}: CheckBoxIconProps & { element: { id: any } }) => {
  const handleClick = (e: React.MouseEvent<SVGElement>) => {
    if (onClick) {
      onClick(e);
      e.stopPropagation();
    }
  };

  switch (variant) {
    case "all":
      return (
        <FaCheckSquare className={className} onClick={handleClick} {...rest} />
      );
    case "none":
      return <FaSquare className={className} onClick={handleClick} {...rest} />;
    case "some":
      return (
        <FaMinusSquare className={className} onClick={handleClick} {...rest} />
      );
    default:
      return null;
  }
};

export default SurveySectionList;
